function openDropdown(navItem) {
  closeDropdowns();
  const navLink = navItem.querySelector(".has-dropdown");
  const navCaret = navItem.querySelector(".caret");

  navLink?.setAttribute("aria-expanded", "true");
  navCaret?.setAttribute("aria-expanded", "true");

  const submenu = navItem.nextElementSibling as HTMLElement;
  if (submenu?.classList.contains("dropdown-content")) {
    const submenuLinks = [...submenu.querySelectorAll("a")];
    submenuLinks.forEach((link) => {
      link.setAttribute("tabindex", "0");
    });
  }

  navItem.classList.add("active");
}

function closeDropdowns() {
  const navItems = document.querySelectorAll(".dropbtn");
  navItems.forEach((navItem) => {
    const navLink = navItem.querySelector(".has-dropdown");
    const navCaret = navItem.querySelector(".caret");

    navLink?.setAttribute("aria-expanded", "false");
    navCaret?.setAttribute("aria-expanded", "false");
    navItem.classList.remove("active");

    const submenu = navItem.nextElementSibling as HTMLElement;
    if (submenu?.classList.contains("dropdown-content")) {
      const submenuLinks = [...submenu.querySelectorAll("a")];
      submenuLinks.forEach((link) => {
        link.setAttribute("tabindex", "-1");
      });
    }
  });
}

// Desktop nav
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-menu");
  const navItems = header?.querySelectorAll(".dropbtn");
  const navCarets = header?.querySelectorAll(".caret");
  const search = header?.querySelector("#search");

  navItems?.forEach((item) => {
    item.addEventListener("mouseover", () => {
      openDropdown(item);
    });
    item.addEventListener("focus", () => {
      closeDropdowns();
    });
  });

  navCarets?.forEach((item) => {
    item.addEventListener("click", () => {
      const navItem = item.parentElement as HTMLElement;
      openDropdown(navItem);
    });
  });

  header?.addEventListener("mouseleave", () => {
    closeDropdowns();
  });
  search?.addEventListener("mouseenter", () => {
    closeDropdowns();
  });
});

// Mobile Nav
const mobileMenu = document.querySelector("#mobile-menu ul");
const menuItems = document.querySelectorAll(".menuItem");
const hamburger = document.querySelector(".hamburger");
const toggleMobile = document.querySelector(".toggle-mobile");

function toggleMenu() {
  if (mobileMenu && hamburger && toggleMobile) {
    if (mobileMenu.classList.contains("showMenu")) {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("mobile-menu-pause-body-scrolling");
      mobileMenu.classList.remove("showMenu");
      toggleMobile.classList.remove("open");
    } else {
      mobileMenu.classList.add("showMenu");
      document
        .getElementsByTagName("body")[0]
        .classList.add("mobile-menu-pause-body-scrolling");
      toggleMobile.classList.add("open");
    }
  }
}

if (hamburger) {
  hamburger.addEventListener("click", toggleMenu);
}
menuItems.forEach(function (menuItem) {
  menuItem.addEventListener("click", toggleMenu);
});


const logo = document.querySelector('#branding a');
const hamburgerElement = hamburger as HTMLElement;
const firstMobileMenuItem = document.querySelector("#mobile-menu")?.querySelector('.dropdown a') as HTMLElement;
const logoElement = logo as HTMLElement;

document.addEventListener('keydown', function (e) {
  if (window.innerWidth < 769) {
    if (e.key === 'Tab' && !e.shiftKey) {
      if (document.activeElement === logo) {
        e.preventDefault();
        hamburgerElement.focus();
      }

      if (document.activeElement === hamburger) {
        if (hamburger?.children[0].classList.contains('open')) {
          e.preventDefault();
          firstMobileMenuItem.focus();
        }
      }
    }

    if (e.key === 'Tab' && e.shiftKey) {
      if (document.activeElement === hamburger) {
        e.preventDefault();
        if (hamburger?.children[0].classList.contains('open')) {
          const lastMenuItem = document.querySelector('.nav-search-mobile a') as HTMLElement;
          lastMenuItem.focus();
        }
        else {
          logoElement.focus();
        }
      }

      if (document.activeElement === firstMobileMenuItem) {
        if (hamburger?.children[0].classList.contains('open')) {
          e.preventDefault();
          hamburgerElement.focus();
        }
      }
    }

    if (e.key === 'Escape') {
      if (hamburger?.children[0].classList.contains('open')) {
        e.preventDefault();
        hamburger.children[0].classList.remove('open');
        logoElement.focus();
      }
    }
  }
});